export const
    formatMoney = (value) => `$${ADV.util.formatValue(ADV.util.numberFrom(value), 'money')}`;
